module.exports = __webpack_public_path__ + "img/IMG_9701_L_Black.b65807fc.jpg";